module.exports = __webpack_public_path__ + "static/media/SWSCRC6-11.65c96cda.mp3";